import React from "react";
import { Box, Grid, MenuItem, Switch } from "@material-ui/core";
import translate from "i18n/translate";
import { SrInput, SrLabel } from "../../../common";

const ShopifyForm = ({
  handleChange,
  errors,
  handleBlur,
  touched,
  values,
  validDays,
  newShopify,
}) => (
  <>
    <Grid item xs={12}>
      <Box>
        <SrLabel>
          {newShopify
            ? translate("applications.newApp.form.oxxoAndMore")
            : translate("applications.newApp.form.oxxo")}
        </SrLabel>
        <Switch
          name="oxxo"
          checked={values.oxxo}
          onChange={handleChange}
          color="primary"
        />
      </Box>
    </Grid>
    {values.oxxo && (
      <Grid item xs={12}>
        <SrInput
          id="valid"
          name="valid"
          variant="outlined"
          select
          onBlur={handleBlur}
          error={errors.valid && touched.valid}
          onChange={handleChange}
          value={values.valid}
          helperText={touched.valid && errors.valid}
          fullWidth
        >
          <MenuItem value="0" disabled>
            {translate("applications.newApp.form.vigencyDays")}
          </MenuItem>
          {validDays?.map((day) => (
            <MenuItem key={day} value={day}>
              {translate("applications.newApp.form.days", { day })}
            </MenuItem>
          ))}
        </SrInput>
      </Grid>
    )}
    <Grid item xs={12}>
      <Box>
        <SrLabel>{translate("applications.newApp.form.msi")}</SrLabel>
        <Switch
          name="msi"
          checked={values.msi}
          onChange={handleChange}
          color="primary"
        />
      </Box>
    </Grid>
  </>
);

export default ShopifyForm;
